module.exports = __webpack_public_path__ + "static/media/1274_1210_Popup.2223992b.png";